import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { SlidersHorizontal, Columns3, Download, Settings, Plus } from "lucide-react";
import { Table, ConfigProvider, Tag, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import Layout from "../../Layout";
import { mixformatCurrency } from "services/mixin";
import { ModalAdd } from "./components/ModalAdd";

import { useLocation } from "react-router-dom";



interface BankItem {
    key: number;
    id: number;
    name: string;
    accountNumber: string;
    bankName: string;
    status: "active" | "inactive";
    receiptCount: number | null;
    paymentCount: number | null;
    transferCount: number | null;
    openingBalance: number | null;
    totalReceipt: number | null;
    totalPayment: number | null;
    totalAmount: number;
    link?: string;
}

const bankData: BankItem[] = [
    {
        key: 1,
        id: 1,
        name: "(M) NGÂN HÀNG MBBANK",
        accountNumber: "12983570538",
        bankName: "Ngân hàng quân đội",
        status: "active",
        receiptCount: 3,
        paymentCount: 9,
        transferCount: 0,
        openingBalance: null,
        totalReceipt: 11994444,
        totalPayment: 192000000,
        totalAmount: -180005556,
        link: "banks/1",
    },
    {
        key: 2,
        id: 2,
        name: "VINADUY - Tpbank",
        accountNumber: "86969698888",
        bankName: "Ngân hàng Tiên Phong",
        status: "active",
        receiptCount: 1,
        paymentCount: 0,
        transferCount: 0,
        openingBalance: null,
        totalReceipt: 150000000,
        totalPayment: 0,
        totalAmount: 150000000,
        link: "banks/2",
    },
    {
        key: 3,
        id: 3,
        name: "Tài khoản NHG",
        accountNumber: "912837189237",
        bankName: "Ngân hàng quân đội",
        status: "inactive",
        receiptCount: null,
        paymentCount: null,
        transferCount: null,
        openingBalance: 120000000,
        totalReceipt: null,
        totalPayment: null,
        totalAmount: 120000000,
        link: "banks/3",
    },
    {
        key: 4,
        id: 4,
        name: "Test tài khoản",
        accountNumber: "123",
        bankName: "Tài khoản VinaPhone",
        status: "active",
        receiptCount: 1,
        paymentCount: 1,
        transferCount: 0,
        openingBalance: null,
        totalReceipt: 150000000,
        totalPayment: 53000000,
        totalAmount: 97000000,
        link: "banks/4",
    },
    {
        key: 5,
        id: 5,
        name: "Tài khoản NV ứng",
        accountNumber: "",
        bankName: "Tiền mặt",
        status: "active",
        receiptCount: 0,
        paymentCount: 1,
        transferCount: 0,
        openingBalance: 0,
        totalReceipt: 0,
        totalPayment: 10000,
        totalAmount: -10000,
        link: "banks/5",
    },
    {
        key: 6,
        id: 6,
        name: "[Vân 01] Ngân hàng MB",
        accountNumber: "123456789",
        bankName: "Tài khoản VinaPhone",
        status: "active",
        receiptCount: 0,
        paymentCount: 1,
        transferCount: 0,
        openingBalance: null,
        totalReceipt: 0,
        totalPayment: 8000000,
        totalAmount: -8000000,
        link: "banks/6",
    },
    {
        key: 7,
        id: 7,
        name: "Phan Anh Tuấn",
        accountNumber: "19191999999999",
        bankName: "Ngân hàng quân đội",
        status: "active",
        receiptCount: 1,
        paymentCount: 1,
        transferCount: 0,
        openingBalance: -2000000000,
        totalReceipt: 4624320932,
        totalPayment: 15000000,
        totalAmount: 2609320932,
        link: "banks/7",
    },
    {
        key: 8,
        id: 8,
        name: "(vân) Ngân hàng MB Bank",
        accountNumber: "123456789",
        bankName: "Ngân hàng quân đội",
        status: "active",
        receiptCount: 2,
        paymentCount: 5,
        transferCount: 0,
        openingBalance: null,
        totalReceipt: 3022400,
        totalPayment: 30651800,
        totalAmount: -27629400,
        link: "banks/8",
    },
];

// const formatNumber = (value: number | null) => {
//     if (value === null) return "--";
//     return value.toLocaleString("vi-VN");
// };

export default function BankList() {
    const { t } = useTranslation();
    const [showModalAdd, setShowModalAdd] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const location = useLocation();

console.log(location.pathname);

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys: React.Key[]) => setSelectedRowKeys(keys),
    };

    const columns: ColumnsType<BankItem> = [
        {
            title: "Tên tài khoản",
            dataIndex: "name",
            key: "name",
            width: 240,
            render: (text, record) => (
                <Link
                    to={`#`}
                    className="block leading-snug"
                >
                    <span className="font-medium text-gray-800 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                        {text}
                    </span>
                    {record.accountNumber && (
                        <span className="block text-xs">
                            {record.accountNumber}
                        </span>
                    )}
                    <span className="block text-xs text-slate-400 dark:text-slate-500">
                        {record.bankName}
                    </span>
                </Link>
            ),
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: 110,
            //   render: (status: BankItem["status"]) => (
            //     <Tag
            //       className="!m-0 !rounded-full !border-0 !px-2.5 !py-0.5 !text-xs !font-medium"
            //       color={status === "active" ? "success" : "error"}
            //     >
            //       {status === "active" ? "Hoạt động" : "Không hoạt động"}
            //     </Tag>
            //   ),
            render: (status: BankItem["status"]) => {
                let colorClass = '';
                let label = '';
                if (status === 'active') { colorClass = 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400'; label = 'Hoạt động'; }
                // else if (status === 'pending') { colorClass = 'bg-orange-100 text-orange-500 dark:bg-orange-900/30 dark:text-orange-400'; label = 'Chờ duyệt'; }
                else if (status === 'inactive') { colorClass = 'bg-red-100 text-red-500 dark:bg-red-900/30 dark:text-red-400'; label = 'Không hoạt động'; }

                return <span className={`px-2 py-1 rounded text-[11px] font-medium inline-block w-full text-center whitespace-nowrap ${colorClass}`}>{label}</span>;
            }
        },
        {
            title: "Phiếu thu",
            dataIndex: "receiptCount",
            key: "receiptCount",
            align: "right",
            width: 100,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {value === null ? "--" : value}
                </span>
            ),
        },
        {
            title: "Phiếu chi",
            dataIndex: "paymentCount",
            key: "paymentCount",
            align: "right",
            width: 100,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {value === null ? "--" : value}
                </span>
            ),
        },
        {
            title: "Phiếu chuyển tiền",
            dataIndex: "transferCount",
            key: "transferCount",
            align: "right",
            width: 140,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {value === null ? "--" : value}
                </span>
            ),
        },
        {
            title: "Số dư đầu kỳ",
            dataIndex: "openingBalance",
            key: "openingBalance",
            align: "right",
            width: 150,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {mixformatCurrency(value,false)}
                </span>
            ),
        },
        {
            title: "Tiền thu",
            dataIndex: "totalReceipt",
            key: "totalReceipt",
            align: "right",
            width: 150,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {mixformatCurrency(value,false)}
                </span>
            ),
        },
        {
            title: "Tiền chi",
            dataIndex: "totalPayment",
            key: "totalPayment",
            align: "right",
            width: 150,
            render: (value: number | null) => (
                <span className="text-slate-600 dark:text-slate-300">
                    {mixformatCurrency(value,false)}
                </span>
            ),
        },
        {
            title: "Tổng tiền",
            dataIndex: "totalAmount",
            key: "totalAmount",
            align: "right",
            width: 160,
            render: (value: number) => (
                <span className="font-medium text-gray-800 dark:text-gray-100">
                    {mixformatCurrency(value,false)}
                </span>
            ),
        },
    ];

    return (
        <Layout>
            <Helmet>
                <title>{t("page.bank_list", "Danh sách tài khoản")} | Khothi</title>
            </Helmet>

            {/* Header */}
            <div className="flex justify-between flex-wrap items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-2">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                    {t("bank.title", "Danh sách tài khoản")}
                </h2>
                <Button
                    type="primary"
                    icon={<Plus size={14} />}
                    onClick={() => setShowModalAdd(true)}
                    className="bg-[#3e91ab] hover:!bg-[#357f96] border-[#3e91ab]"
                >
                    Thêm mới
                </Button>
            </div>

            {/* Toolbar */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900">
                <div className="flex items-center gap-3 text-slate-500 dark:text-slate-400 text-xs">
                    <button className="hover:text-slate-800 dark:hover:text-slate-100 transition-colors">
                        <SlidersHorizontal className="w-4 h-4" />
                    </button>
                    <button className="hover:text-slate-800 dark:hover:text-slate-100 transition-colors">
                        <Columns3 className="w-4 h-4" />
                    </button>
                    {selectedRowKeys.length > 0 ? (
                        <span>
                            Đã chọn <b>{selectedRowKeys.length}</b> bản ghi
                        </span>
                    ) : (
                        <span>
                            Hiển thị 1 - {bankData.length} / {bankData.length} bản ghi
                        </span>
                    )}
                </div>

                <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <Download className="w-4 h-4" />
                        <span>Export</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <Settings className="w-4 h-4" />
                        <span>Cài đặt</span>
                    </button>
                </div>
            </div>

            {/* Ant Design Table */}
            <div className="py-4">
                <ConfigProvider
                    theme={{
                        components: {
                            Table: {
                                headerBg: "#f8f9fa",
                                headerColor: "#6b7280",
                                cellPaddingBlock: 12,
                                rowHoverBg: "#eff6ff",
                            },
                        },
                    }}
                >
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={bankData}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                    />
                </ConfigProvider>
            </div>

            <ModalAdd open={showModalAdd} onClose={() => setShowModalAdd(false)}/>
        </Layout>
    );
}